export const hover = '#2B3382';
export const hoverNd = '#F47D42';
export const darkGreen = '#0055A4'
export const scotch = `"Scotch Display", Arial, sans-serif;`;
export const helvetica = `"Helvetica", Arial, sans-serif`;

